
import { homeConstants } from '../constants';

import { func_validation, func_serviceHandling } from 'functions';

import { promiseInstance_authorization } from './config';
import { Toaster } from 'components/notification/Toaster';



export const homeActions = {
	getOneClickActionDetails,
	getCompanyDetails,
}

function getOneClickActionDetails() {
    return dispatch => {
        dispatch(request());

        promiseInstance_authorization(dispatch, request, (axios) => {
			axios.get('/Dashboard/DealerPortal')
				.then(function (details) {
					// handle success
					dispatch(success(details));
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: homeConstants.getOneClickActionDetails_request, details }; }
    function success(details) { return { type: homeConstants.getOneClickActionDetails_success, details }; }
    function failure(error) { return { type: homeConstants.getOneClickActionDetails_failure, error }; }
}

function getCompanyDetails(pageNo, pageSize, sort, filterOptions) {
    return dispatch => {
		dispatch(request());

		let isOffsetValid = func_validation.isNumberValid(pageNo) && func_validation.isNumberValid(pageSize);
		let offset = isOffsetValid? pageNo * pageSize:0;

		let paramObj = {
			offset: offset,
			limit: pageSize,
			sort: sort,
			...filterOptions
		}

		let url = func_serviceHandling.createUrlWithParams('/ComInfo/GetComId', paramObj)

		promiseInstance_authorization(dispatch, request, (axios) => {
			axios.get(url)
				.then(function (details) {
					// handle success
					dispatch(success(details));
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));

					let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to get COM details";
					Toaster({ type: "error", msg });
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: homeConstants.getCompanyDetails_request, details }; }
    function success(details) { return { type: homeConstants.getCompanyDetails_success, details }; }
    function failure(error) { return { type: homeConstants.getCompanyDetails_failure, error }; }
}